// extracted by LIB_CSS_EXTRACT_LOADER
import "./radio-group_module.css"
export default {"group":"group-pdU0M9","item":"item-RwPhcM","indicator":"indicator-y5Uthw","icon":"icon-ZtI68F"};